import {
  Box,
  TypographyStylesProvider,
  Image,
  Alert,
  Text,
  Code,
} from "@mantine/core";
import React from "react";

import SimpleImage from "../articlesHelpers/SimpleImage";
import { IconAlertTriangle } from "@tabler/icons-react";

export const USE_RIZFUL_BTC_PAY_SERVER = (
  <TypographyStylesProvider>
    <p>
      BTCPay server needs to be connected with a Lightning Node in order to
      receive payments.{" "}
    </p>

    <p>
      Rizful is a high-performance, cloud-based Lightning Node that will always
      be online for your customers.
    </p>
    <p>It takes about two minutes to connect Rizful and BTCPay.</p>
    <SimpleImage src="docs_images/btcpay-logo.png" h={180} />
    <p>
      1. Follow{" "}
      <a
        href="/docs/connecting-apps#nostr-wallet-connect-send-and-receive"
        target="_blank"
      >
        these instructions
      </a>{" "}
      to get a <strong>NWC Send & Receive Connection</strong> code from Rizful.
    </p>
    <p>
      {" "}
      You'll get a code that looks like this:{" "}
      <code>nostr+walletconnect://p&9XTp@dGjsUE5BwM....</code>
    </p>
    <p>2. In BTCPay server, click "Manage Plugins"</p>
    <SimpleImage src="docs_images/manage-plugins.png" h={220} />
    <p>3. Search for the "Nostr" plugin, then click "install".</p>
    <SimpleImage src="docs_images/search-for-nostr-then-install.png" h={350} />
    <p>4. Restart BTCPay server.</p>
    <SimpleImage src="docs_images/restart-now.png" h={100} />
    <p>5. Click "Lightning".</p>
    <SimpleImage src="docs_images/click-lightning.png" h={350} />
    <p>6. Click "Use custom node".</p>
    <SimpleImage src="docs_images/use-custom-node.png" h={150} />
    <p>
      7. Paste your NWC code from Rizful (that looks like{" "}
      <code>nostr+walletconnect://p&9XTp..</code>) into the form field, and
      click "Test connection".
    </p>
    <SimpleImage src="docs_images/enter-nwc-code-and-click-test.png" h={250} />
    <p>7. You should see that the connection was successful.</p>
    <SimpleImage src="docs_images/connection-successful.png" h={150} />
    <p>8. Click "Save"</p>
    <SimpleImage src="docs_images/then-click-save.png" h={150} />
    <p>8. You should now see your Rizful node's balance in BTCPay!</p>
    <SimpleImage src="docs_images/u-have-a-balance.png" h={350} />
    <p>
      9. Under Wallets / Lightning / Settings, make sure "Enable LNURL" is
      unchecked.
    </p>
    <SimpleImage src="docs_images/uncheck-lnurl-in-btcpay.png" h={450} />
    <p>
      That's it! You can now use Rizful to receive Lightning payments in BTCPay!
    </p>
  </TypographyStylesProvider>
);
